import BaseLayer from "./BaseLayer";
import {plotStitchGraphHelper, plotStitchGraphStartPositions} from "../utils/map_utils";

class StitchRound0Graphv2 extends BaseLayer {

    id = "stitchRound0Graphv2";
    label = "Path";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPathR0, stitchStartPosR0} = this.props;
        plotStitchGraphStartPositions(stitchStartPosR0, this.props.slide, this.layer.getSource());
        plotStitchGraphHelper(stitchPathR0, this.props.slide, this.layer.getSource());
        resolve();
    });
}

export default StitchRound0Graphv2;
